import { deliveryConstants } from '../constants'

const cleanAll = () => ({
  type: deliveryConstants.CLEAN_ALL
})

const setDniPhoto = image => ({
  type: deliveryConstants.SET_DNI_PHOTO,
  image
})

const setClientPhoto = image => ({
  type: deliveryConstants.SET_CLIENT_PHOTO,
  image
})

const setSign = image => ({
  type: deliveryConstants.SET_SIGN,
  image
})

const setOc = oc => ({
  type: deliveryConstants.SET_OC,
  oc
})

export const deliveryActions = {
  cleanAll,
  setDniPhoto,
  setClientPhoto,
  setSign,
  setOc
}
